var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "py-4" }, [
    _c(
      "div",
      { staticClass: "col-12 pr-0 flex overall" },
      [
        _c("div", { staticClass: "col-1 rating-grade" }, [
          _c("span", { staticClass: "rating-avg" }, [
            _vm._v("\n        " + _vm._s(_vm.rating) + "\n      ")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "text-uppercase rating-sub" }, [
            _vm._v("\n        out of 5\n      ")
          ])
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        [
          _c(
            "div",
            { staticClass: "col-5 review-stars-info stars-container" },
            [
              _vm._l(_vm.ratingPercentages, function(value, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "progress mb-1",
                    staticStyle: { height: "8px" }
                  },
                  [
                    _c("div", {
                      staticClass: "progress-bar",
                      style: { width: value.value + "%" },
                      attrs: {
                        role: "progressbar",
                        "aria-valuemin": "0",
                        "aria-valuemax": "100"
                      }
                    })
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex justify-content-end align-content-start"
                },
                [
                  _c("p", { staticClass: "ratings-text text-uppercase" }, [
                    _vm._v("Based on " + _vm._s(_vm.ratingNumber) + " Reviews")
                  ])
                ]
              )
            ],
            2
          )
        ]
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-1 pr-2 text-right stars-container" }, [
      _c("div", { staticClass: "stars" }, [
        _c("i", { staticClass: "fa fa-star" }),
        _c("i", { staticClass: "fa fa-star" }),
        _c("i", { staticClass: "fa fa-star" }),
        _c("i", { staticClass: "fa fa-star" }),
        _c("i", { staticClass: "fa fa-star" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "stars" }, [
        _c("i", { staticClass: "fa fa-star" }),
        _c("i", { staticClass: "fa fa-star" }),
        _c("i", { staticClass: "fa fa-star" }),
        _c("i", { staticClass: "fa fa-star" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "stars" }, [
        _c("i", { staticClass: "fa fa-star" }),
        _c("i", { staticClass: "fa fa-star" }),
        _c("i", { staticClass: "fa fa-star" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "stars" }, [
        _c("i", { staticClass: "fa fa-star" }),
        _c("i", { staticClass: "fa fa-star" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "stars" }, [
        _c("i", { staticClass: "fa fa-star" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b488cd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b488cd6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/ratings/Rating.vue
// module id = null
// module chunks = 